module.exports = __webpack_public_path__ + "img/menu-debt-notifications.278affd2.svg";